import React, { Component } from 'react';
import InputForm from '../atoms/inputForm';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import _ from 'lodash';
import { TYPES, getUserInfo, salonUpdateReminderMsg } from '../../../actions';

import { LANGUAGES, getTranslate, checkValidate, notify } from '../../../utils';
import '../../../styles/components/salon-reminder-setting.scss';

const $ = window.$;

class SalonReminderSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      userInfo: props.userInfo,

      form: {
        enable_reminder_msg: 0,
        msg_reminder_template: '',
      },
      formIsValid: false,
      msg: {},
      userInfo: null,
      template: '',
      maxLengthTemplate: 800,

      remind_day_before: '1',
      remind_at_hour: '5',

      default: {
        remind_day_before: '1',
        remind_at_hour: '5',
      },
      min_hour: 3,

      tags: [
        { label: 'お客様のLINE表示名', value: '{{line_user_name}}', length: 20 },
        { label: '店舗名', value: '{{salon_name}}', length: 30 },
        { label: 'キャンセルURL', value: '{{url_cancel_booking}}', length: 60 },
        { label: '来店日時', value: '{{booking_date}}', length: 18 },
        { label: '所要時間', value: '{{total_time}}', length: 4 },
        { label: 'コース名', value: '{{service_name}}', length: 30 },
        { label: '合計金額', value: '{{total_price}}', length: 8 },
      ].map((t) => ({ ...t, valueSample: Array(t.length).fill('1').join('') })),

      actionNotify: {
        time: +new Date(),
      },
    };

    this.editorRef = React.createRef();
    this.savedRange = null;
  }

  componentDidMount() {
    this.props.getUserInfo();

    const editor = this.editorRef.current;
    editor.addEventListener('mouseup', this.saveSelection);
    editor.addEventListener('keyup', this.saveSelection);
    editor.addEventListener('mouseleave', this.saveSelection);
    // editor.addEventListener('beforeinput', this.onHandleBeforeInput, { cancelable: true });
  }

  componentWillUnmount() {
    const editor = this.editorRef.current;
    editor.removeEventListener('mouseup', this.saveSelection);
    editor.removeEventListener('keyup', this.saveSelection);
    editor.removeEventListener('mouseleave', this.saveSelection);
    // editor.removeEventListener('beforeinput', this.onHandleBeforeInput);
  }

  UNSAFE_componentWillReceiveProps(props) {
    // console.log('Unsafe component will receive props: ', props);
    if (JSON.stringify(this.state.userInfo) != JSON.stringify(props.userInfo)) {
      let time_reminder = _.get(props, 'userInfo.time_reminder', '') || '';
      let remind_day_before = time_reminder.split('_')[0] || this.state.default.remind_day_before;
      let remind_at_hour = time_reminder.split('_')[1] || this.state.default.remind_at_hour;
      this.setState(
        {
          userInfo: props.userInfo,
          enable_reminder_msg: _.get(props, 'userInfo.enable_reminder_msg', '0'),
          template: _.get(props, 'userInfo.msg_reminder_template', '') || '',
          remind_day_before,
          remind_at_hour,
        },
        () => {
          this.insertTemplate();
          this.handleCheckFormError();
        }
      );
    }

    if (!_.isEmpty(props.actionNotify) && props.actionNotify.time > this.state.actionNotify.time) {
      switch (props.actionNotify.type) {
        case TYPES.ACTION_SALON_UPDATE_REMINDER_MSG_SUCCESS:
          this.props.getUserInfo();
          setTimeout(() => {
            notify('予約リマインド配信の設定が完了しました。', 'success');
          }, 200);

          break;

        default:
          break;
      }
      this.setState({
        actionNotify: props.actionNotify,
      });
    }
  }

  onChangeFormField = (e, field) => {
    const value = e.target.value || '';
    // let newForm = {
    //   ...this.state.form,
    //   [field]: value,
    // };

    console.log('onChangeFormField', field, value);

    this.setState(
      {
        // form: newForm,
        // msg: {},
        [field]: value,
      },
      () => {
        this.handleCheckFormError();
      }
    );

    // if (this.form) this.form.classList.remove('was-validated');
  };

  onChangeTimeReminder = (field, e) => {
    let newValue = e.target.value;
    let newState = {
      [field]: newValue,
    };
    // if (field == 'remind_day_before' && newValue == 0 && this.state.remind_at_hour < this.state.min_hour) {
    //   newState = {
    //     ...newState,
    //     remind_at_hour: this.state.min_hour,
    //   };
    // }
    this.setState(newState);
  };

  handleCheckFormError = () => {
    let msg = {};

    if (Number(this.state.enable_reminder_msg)) {
      if (!this.state.template.trim()) {
        msg['template'] = 'リマインドメッセージを入力してください。';
      }
    }

    let formIsValid = _.isEmpty(msg);

    this.setState({
      msg,
      formIsValid,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    this.form = form;

    let msg = {};

    if (Number(this.state.enable_reminder_msg)) {
      if (!this.state.template.trim()) {
        msg['template'] = 'リマインドメッセージを入力してください。';
      }
    }

    let formIsValid = _.isEmpty(msg);

    this.setState({
      msg,
      formIsValid,
    });

    // document.getElementById('editor').setCustomValidity(_.get(msg, 'template', ''));

    console.log('msg', msg);

    if (form.checkValidity() === false || !formIsValid) {
      e.preventDefault();
      e.stopPropagation();
      console.log('form is invalid');
    } else {
      console.log('form is valid');

      let postData = {
        enable_reminder_msg: this.state.enable_reminder_msg == '1' ? 1 : 0,
        msg_reminder_template: this.state.template,
        time_reminder: [this.state.remind_day_before, this.state.remind_at_hour].join('_'),
      };

      console.log('postData', postData);

      this.props.salonUpdateReminderMsg(postData);
    }

    form.classList.add('was-validated');
  };

  saveSelection = () => {
    // const selection = window.getSelection();
    // if (selection.rangeCount > 0) {
    //   this.savedRange = selection.getRangeAt(0).cloneRange();
    //   // console.log('savedRange', this.savedRange);
    // }

    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    if (!this.isRangeInsideEditor(range, this.editorRef.current)) return;

    this.savedRange = range;
  };

  isRangeInsideEditor = (range, editor) => {
    if (!range || !editor) return false;
    let container = range.commonAncestorContainer;
    while (container) {
      if (container === editor) return true;
      container = container.parentNode;
    }
    return false;
  };

  insertTag = (tag) => {
    if (this.calculateTemplateLength() + tag.length > this.state.maxLengthTemplate) {
      return;
    }

    if (!this.savedRange || !this.isRangeInsideEditor(this.savedRange, this.editorRef.current)) {
      this.editorRef.current.focus();
      this.saveSelection();
      setTimeout(() => {
        this.insertTag(tag);
      }, 10);
      return;
    }

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(this.savedRange);

    const range = selection.getRangeAt(0);
    range.deleteContents();

    const span = document.createElement('span');
    span.className = 'tag-span';
    span.contentEditable = 'false';
    span.innerText = tag.label;
    span.setAttribute('data-value', tag.value);
    span.setAttribute('data-label', tag.label);

    range.insertNode(span);

    const space = document.createTextNode(' ');
    range.setStartAfter(span);
    range.insertNode(space);

    range.setStartAfter(space);
    range.setEndAfter(space);
    selection.removeAllRanges();
    selection.addRange(range);

    this.saveSelection();
    this.exportToText();
  };

  onHandlePaste = (e) => {
    let templateLength = this.calculateTemplateLength() + e.clipboardData.getData('text').length;

    let isGotMaxLength = templateLength > this.state.maxLengthTemplate;
    if (isGotMaxLength) {
      e.preventDefault();
    }

    // console.log('onHandlePase', e);
  };

  onHandleKeyDown = (e) => {
    console.log('onHandleKeyDown', e.key, e);

    if (e.key === 'Backspace' || e.key === 'Delete') {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        if (range.collapsed) {
          const node = range.startContainer;
          const offset = range.startOffset;

          if (node.nodeType === Node.TEXT_NODE) {
            if (offset > 0) return;

            const prev = node.previousSibling;
            if (prev && prev.classList && prev.classList.contains('tag-span')) {
              e.preventDefault();
              prev.remove();
            }
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            const child = node.childNodes[offset - 1];
            if (child && child.classList && child.classList.contains('tag-span')) {
              e.preventDefault();
              child.remove();
            }
          }
        }
      }

      this.exportToText();

      return;
    }

    if (['{', '}'].indexOf(e.key) > -1) {
      e.preventDefault();
      return;
    }

    if (this.calculateTemplateLength() > this.state.maxLengthTemplate - 1 && ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].indexOf(e.key) == -1) {
      e.preventDefault();
      return;
    }
  };

  // onHandleBeforeInput = (e) => {
  //   const editor = this.editorRef.current;

  //   const isDeletion = e.inputType === 'deleteContentBackward' || e.inputType === 'deleteContentForward';

  //   console.log('onHandleBeforeInput', e.data, e.inputType);
  //   if (this.calculateTemplateLength() > this.state.maxLengthTemplate - 1) {
  //     if (isDeletion) {
  //       return;
  //     }
  //     console.log('onHandleBeforeeInput preventDefault');
  //     editor.blur();
  //     e.preventDefault(); // prevent adding new characters
  //   }
  // };

  onHandleInput = () => {
    this.exportToText();
  };

  getTemplate = (element, level = 0) => {
    let result = '';

    $(element)
      .find('.tag-span')
      .toArray()
      .forEach((x) => {
        $(x).text($(x).attr('data-value'));
      });

    result = element.innerText;
    result = result
      .replace(/\r\n|\r|\n/g, '\n')
      .replace(/\n{2}/g, '\n')

      .replace(/\n$/, '');

    $(element)
      .find('.tag-span')
      .toArray()
      .forEach((x) => {
        $(x).text($(x).attr('data-label'));
      });

    return result;
  };

  exportToText = () => {
    const editor = this.editorRef.current;
    const template = this.getTemplate(editor);
    this.setState(
      {
        template,
      },
      () => {
        this.handleCheckFormError();
      }
    );
    console.log('\t exportToText template', JSON.stringify(template));
  };

  parseTemplate = (container, template) => {
    console.log('parseTemplate', template);
    const regex = /(\{\{[^}]+\}\})/g;

    let lines = template.split(/(?<=\n)/);

    // console.log('lines', lines);
    lines.forEach((line, lIdx) => {
      let div;

      if (!lIdx) {
        div = container;
      } else {
        div = document.createElement('div');
        container.appendChild(div);
      }
      // let
      const parts = line.split(regex).filter((l) => l);

      // console.log('parts', parts);

      parts.forEach((part) => {
        if (part.startsWith('{{') && part.endsWith('}}')) {
          let tag = this.state.tags.find((x) => x.value === part);
          if (tag) {
            const span = document.createElement('span');
            span.className = 'tag-span';
            span.contentEditable = 'false';
            span.innerText = tag.label;
            span.setAttribute('data-value', tag.value);
            span.setAttribute('data-label', tag.label);

            div.appendChild(span);
          }
        } else {
          // if (parts.length == 1 && parts[0] == '') {
          //   div.appendChild(document.createElement('br'));
          // } else {
          //   div.appendChild(document.createTextNode(part));
          // }
          if (part == '\n') {
            div.appendChild(document.createElement('br'));
          } else {
            let cs = part.split('\n');
            cs.forEach((p, pIdx) => {
              if (p == '' && pIdx < cs.length - 1) {
                div.appendChild(document.createElement('br'));
              } else {
                div.appendChild(document.createTextNode(p));
              }
            });
          }
        }
      });
    });

    return container;
  };

  insertTemplate = () => {
    // const template = `abc{{booking_require_time}}def{{cancel_url}}abc\n{{salon_name}}a content`;
    if (this.editorRef.current) {
      this.editorRef.current.innerHTML = '';
      this.parseTemplate(this.editorRef.current, this.state.template);
    }
  };

  calculateTemplateLength = () => {
    let template = this.state.template || '';
    for (let i = 0; i < this.state.tags.length; i++) {
      const tag = this.state.tags[i];
      template = template.replace(new RegExp(tag.value, 'g'), tag.valueSample);
    }

    return template.length;
  };

  render() {
    let templateLength = this.calculateTemplateLength();

    let isGotMaxLength = templateLength > this.state.maxLengthTemplate;

    const { error } = this.state;

    let dayValues = Array(8)
      .fill()
      .map((x, idx) => idx)
      .filter((x) => x >= 1 && x <= 7);
    let hourValues = Array(24)
      .fill()
      .map((x, idx) => idx)
      .filter((x) => x >= 0 && x <= 23);
    // if (this.state.remind_day_before == 0) {
    //   hourValues = hourValues.filter((x) => x >= this.state.min_hour);
    // }

    return (
      <div className="salon-reminder-setting text-center">
        <div className="d-flex justify-content-center">
          <form noValidate autoComplete="off" className={'needs-validation'} style={{ width: '90%', maxWidth: 500 }}>
            <div className="mx-auto" style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'start', color: 'black', fontSize: '16px' }}>
              <label className="w-100 font-weight-bold" style={{ fontSize: '26px' }}>
                予約リマインド配信
              </label>
              <div className="d-flex flex-row w-100 justify-content-center fs-16">
                <label className="rdb-enable-reminder-msg mr-4">
                  有効にする
                  <input
                    type="radio"
                    name="enable_reminder_msg"
                    value="1"
                    checked={this.state.enable_reminder_msg == '1'}
                    onChange={(e) => this.onChangeFormField(e, 'enable_reminder_msg')}
                    className="mr-1"
                  />
                  <span className="checkmark"></span>
                </label>
                <label className="rdb-enable-reminder-msg">
                  無効にする
                  <input
                    type="radio"
                    name="enable_reminder_msg"
                    value="0"
                    checked={this.state.enable_reminder_msg == '0'}
                    onChange={(e) => this.onChangeFormField(e, 'enable_reminder_msg')}
                    className="mr-1"
                  />
                  <span className="checkmark"></span>
                </label>
              </div>

              <label className="font-weight-bold">配信タイミング</label>
              <div className="d-flex w-100 fs-16 mb-2 pl-0 pl-sm-4 justify-content-center justify-content-sm-start">
                <label className="m-0">予約</label>
                <div className="ml-4 mr-2" style={{ minWidth: '60px' }}>
                  <select className="form-control" onChange={(e) => this.onChangeTimeReminder('remind_day_before', e)} value={this.state.remind_day_before}>
                    {dayValues.map((x) => (
                      <option key={x} value={x}>
                        {x}
                      </option>
                    ))}
                  </select>
                </div>
                <label className="m-0">日前の</label>

                <div className="ml-4 mr-2" style={{ minWidth: '65px' }}>
                  <select className="form-control" onChange={(e) => this.onChangeTimeReminder('remind_at_hour', e)} value={this.state.remind_at_hour}>
                    {hourValues.map((x) => (
                      <option key={x} value={x}>
                        {x}
                      </option>
                    ))}
                  </select>
                </div>
                <label className="m-0">時</label>
              </div>

              <label className="font-weight-bold">配信メッセージ</label>
              <div className="d-flex w-100 flex-wrap fs-16 mb-2">
                {this.state.tags.map((tag) => (
                  // <span style={{ padding: '4px', margin: '4px', border: '1px solid black', borderRadius: '5px' }} key={t.value}>
                  //   {t.label}
                  // </span>

                  <button
                    type="button"
                    key={tag.value}
                    className="tag-button cursor-pointer bg-white"
                    disabled={isGotMaxLength}
                    onMouseDown={(e) => {
                      e.preventDefault(); // Prevent focus loss
                      this.insertTag(tag);
                    }}
                  >
                    {tag.label}
                  </button>
                ))}
              </div>

              <div
                id="editor"
                className={`editor-template ${isGotMaxLength || this.state.msg.template ? 'error-max-length' : ''}`}
                ref={this.editorRef}
                contentEditable="true"
                onInput={this.onHandleInput}
                onKeyDown={this.onHandleKeyDown}
                onPaste={this.onHandlePaste}
              />
              {this.state.msg.template && <div className={'text-left fs-12 text-danger mt-1'}>{this.state.msg.template || ''}</div>}

              <div className="w-100 d-flex justify-content-between">
                <label className="font-weight-bold text-left text-danger">{isGotMaxLength ? `最大${this.state.maxLengthTemplate}文字までです` : ''}</label>

                <label className="font-weight-bold text-right">
                  {templateLength}/{this.state.maxLengthTemplate}
                </label>
              </div>

              {error && <div style={{ color: 'red' }}>{error}</div>}

              <button
                disabled={!this.state.formIsValid || isGotMaxLength}
                style={{ width: '100%', fontWeight: 'bold', fontSize: '22px' }}
                type="button"
                className="btn btn-success btn-block btn-round"
                onClick={this.handleSubmit}
              >
                保存
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { staffReducer, userReducer } = state;

  return {
    actionNotify: staffReducer.actionNotify,
    userInfo: userReducer.userInfo,
  };
}

export default connect(mapStateToProps, {
  getUserInfo,
  salonUpdateReminderMsg,
})(SalonReminderSetting);
